<template>
    <div class="total"  :ref="model === false ? 'total' : 'totalModel'">
        <div class="topback"  :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed'}" v-if="model === false">
          <headtip  :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
        </div>
        <GptDesign :isMerge="isMerge" :isShowHead="true" />
        <GptTranslate :isMerge="isMerge" :isShowHead="false"  />
        <GptTechnology :isMerge="isMerge" :isShowHead="false"  />
        <bottomTip></bottomTip>
        <kefuMobile @topMobile="topMobile" v-if="model !== false"></kefuMobile>
    </div>
</template>
<script>
import GptDesign from "./gptDesign";
import GptTranslate from "./gptTranslate.vue";
import GptTechnology from "./gptTechnology.vue";
import headtip from "@/views/headTip.vue";
import {shareUrl} from "@/utils/vxshare";
import bottomTip from "@/views/bottomTip.vue";
import kefuMobile from "@/views/kefuMobile.vue";
export default {
    name: "oilfieldAI",
    data() {
        return {
            changeVisable: 1,
            isMerge: true,
            model: false,
            scrollback:false,
            dialogconsult:false,
            pageTitle: 'Oil & Gas Development AI Products & Customized Services - Oil & Gas Communication GPT',
            pageDescription: 'Covering multiple business scenarios such as engineering, production, and stations, we assist customers in cost reduction and efficiency improvement, as well as achieving intelligent upgrades, through data governance, model development, and system integration.',
            pageKeywords: 'Oil & Gas Development AI Products & Customized Services, Design GPTs, design-type GPTs, fracturing design plan parameter optimization, drilling engineering plan design, Oil & Gas field development design, Oil & Gas communication, Oil & Gas communication GPT, Oil & Gas communication GPT cloud platform, Oil & Gas communication large model, Oil & Gas communication GPT large model',
        }
    },  
    components: {
        GptDesign,
        GptTranslate,
        GptTechnology,
        headtip,
        bottomTip,
        kefuMobile
    },  
    methods: {
        changeheadVisable(){
            if(this.changeVisable===1){
                this.changeVisable=0
            }
            else{
                this.changeVisable=1
            }
        },
        handleScroll() {
            if(this.model===false){
                this.scrollHeight = this.$refs.total.scrollTop;
            }
            else{
                this.scrollHeight = this.$refs.totalModel.scrollTop;
            }

            if( this.scrollHeight<100){
                this.scrollTrue=true
            }
            else{
                this.scrollTrue=false
            }
            if( this.scrollHeight<50){
                this.scrollback=false
            }
            else{
                this.scrollback=true
            }
        },
        topMobile() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        setMetaTags() {
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute('content', this.pageDescription);
            }

            const metaKeywords = document.querySelector('meta[name="keywords"]');
            if (metaKeywords) {
                metaKeywords.setAttribute('content', this.pageKeywords);
            }
        },
        skipp3() {
            const element = this.$refs.bottom;
            const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

            this.$nextTick(() => {
                this.$refs.totalModel.scrollTop = rect
            });
        },
        showPartner() {
            this.dialogconsult = true;
        },
        hide() {
            this.dialogconsult = false;
        },
    },
    mounted(){
        this.$refs.total.addEventListener('scroll', this.handleScroll);
     
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(screenWidth<=700){
            this.model=true
        }else{
            this.model=false
        }
        if (localStorage.getItem("skip") === '3') {
            this.$nextTick(() => {
                this.skipp3();
            });
        }

        

        document.title = this.pageTitle;
        this.setMetaTags();

        localStorage.setItem("home",0)
        let url = window.location.href
        // let url = 'https://oilgasinfoai.com/?language=zh'
        setTimeout(() => {
            //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
            let shareData = {
                url: url,
                pageTitle: this.pageTitle,
                pageDescription: this.pageDescription,
                pageKeywords: this.pageKeywords
            };
            shareUrl(shareData);
        }, 1000);
    },
    beforeDestroy() {
        this.$refs.total.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
.total {
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  position: relative;
  .topback{
    position: fixed;
    z-index:999;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }
}
</style>